import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Dataset, DatasetRepo, deepClone, EppPortlet, PageConfig, PageFilterConfig, Portlet, PortletInstance, PortletRepo, uuidv4 } from '@gspwidget/util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-page-filter-modal',
  templateUrl: './page-filter-modal.component.html',
  styleUrls: ['./page-filter-modal.component.scss']
})
export class PageFilterModalComponent implements OnInit {

  pageConfig?: PageConfig
  /**
   * 已配置的筛选控件配置。
   * 传值是编辑，但无论如何都不会改变传入的配置对象；
   * 不传就新建。
   */
  originalFilter?: PageFilterConfig
  /**
   * 此模态框产生的结果 filter，即当前配置出来的筛选控件配置。
   */
  filter?: PageFilterConfig

  /**
   * 左侧部件实例列表
   */
  public flatPInsList: PortletInstance[] = []

  constructor(
    public datasetRepo: DatasetRepo,
    public cd: ChangeDetectorRef,
    public translate: TranslateService,
    public portletRepo: PortletRepo,
  ) { }

  async ngOnInit() {
    this.filter = this.originalFilter
      ? deepClone(this.originalFilter)
      : new PageFilterConfig()
    
    this.flatPInsList = [...this.pageConfig.layout]

    this.addShellInsidersToFlatPInsList()
    await this.loadNSetAllPInsDataset()
    await this.buildTargetsFromPInsList()
    this.cd.markForCheck()
  }

  /**
   * 把容器里的部件的 pIns 加入到 flatPInsList，其中不包含 portlet，
   * 异步数据获取统一放在后面
   */
  addShellInsidersToFlatPInsList() {
    this.pageConfig.layout
      .filter((pIns) => pIns.feOnly.widgetComp && !!pIns.feOnly.widgetComp.propValues.tabConfigs)
      .forEach((shellPIns) => {
        shellPIns.feOnly.widgetComp.propValues.tabConfigs.forEach(tabConfig => {
          tabConfig.portletIds.forEach(portletId => {
            this.flatPInsList.push({
              portletId,
              instanceId: uuidv4(),
              gridsterItem: null,
              isBAPortlet: shellPIns.isBAPortlet,
            })
          })
        })
      })
  }

  async loadNSetAllPInsDataset () {
    const loadNSetPInsDataset$ = this.flatPInsList.map(async pIns => {
        // 容器部件的 portlet 此时是空的，得发请求获得
        if (!<EppPortlet>pIns.portlet) {
          pIns.portlet = await this.portletRepo.getPortletById(pIns.portletId).toPromise()
        }
        // 根本不接数据集的部件，不用继续向下走
        if (!(<EppPortlet>pIns.portlet).datasetId) return
        const dataset = await this.datasetRepo.getDatasetById((<EppPortlet>pIns.portlet).datasetId).toPromise()
        if (!pIns.feOnly) pIns.feOnly = {}
        pIns.feOnly.dataset = dataset
    })
    return Promise.all(loadNSetPInsDataset$)
  }

  async buildTargetsFromPInsList() {
    this.filter.targets = this.flatPInsList.map(this.convertPInsToFilterTarget.bind(this))
  }

  private convertPInsToFilterTarget (pIns: PortletInstance) {
    const originalTarget = this.filter.targets.find(t => t && t.portletId === pIns.portletId)
    return pIns.feOnly.dataset
      ? {
        portletId: pIns.portletId,
        enabled: originalTarget ? originalTarget.enabled : false,
        dpId: originalTarget ? originalTarget.dpId : null
      }
      : null
  }

}
